module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/hollywood_3x.2012cf6.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/hollywood_3x.png
// module id = 1HE7
// module chunks = 41